import { SystemSpaceSlug } from '@bettermode/common/space'
import { SpaceImage } from '@tribeplatform/react-components/Space'
import { useRouter } from '@tribeplatform/react-sdk'
import { useSpaceUtil } from '@tribeplatform/react-sdk/hooks'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { useCustomizerSpace } from '../Editor/hooks/index.js'

export const SpaceBlocksSidebarTitle = () => {
  const { Link } = useRouter()
  const { space } = useCustomizerSpace()
  const { generateProfilePath } = useSpaceUtil()

  const spaceRelativeUrl =
    space?.slug === SystemSpaceSlug.MEMBER
      ? generateProfilePath()
      : space?.relativeUrl

  if (!space) {
    return null
  }

  return (
    <div className="flex justify-between items-center gap-2">
      <div className="flex items-center gap-2 flex-1 min-w-0">
        <SpaceImage space={space} size="lg" />
        <Link
          variant="inherit"
          href={spaceRelativeUrl ?? '/'}
          target="_blank"
          className="flex items-baseline gap-1 min-w-0"
        >
          <span className="truncate">{space.name}</span>
          <SvgIcon name="link-external" size="xs" />
        </Link>
      </div>
    </div>
  )
}
